import { BackendOnlyResource as e } from "./BackendOnlyResource.js";
import { API as t, Resource as n } from "@coveo/platform-client";
//#region src/resources/DataServiceResource.ts
var r = (e) => "errorInfo" in e, i = (e) => !e.queryResponses.some(r), a = (e) => Object.prototype.toString.call(e) === "[object Temporal.PlainDateTime]", o = (e) => {
	if (e instanceof Date) return e.toISOString();
	if (a(e)) return `${e.toString()}Z`;
}, s = async (e) => {
	let t = await e;
	if (i(t)) return t;
	throw Object.defineProperty(Error(t.queryResponses.reduce((e, t, n) => r(t) ? e + `\n [${n}] ${t.errorInfo.errorCode}` : e, "Queries encountered one or more errors:")), "queryResponses", {
		enumerable: !0,
		value: t.queryResponses
	});
}, c = class e extends n {
	static {
		this.baseUrl = `/rest/organizations/${t.orgPlaceholder}/data/v1`;
	}
	listTables(t, n) {
		return this.api.get(super.buildPath(`${e.baseUrl}/tables`, t), n);
	}
	query(t, n) {
		let { fromDate: r, toDate: i, previousFromDate: a, previousToDate: s } = t;
		return this.api.post(super.buildPath(`${e.baseUrl}/query`), {
			...t,
			fromDate: o(r),
			toDate: o(i),
			previousFromDate: o(a),
			previousToDate: o(s)
		}, n);
	}
	queries(t, n) {
		return s(this.api.post(super.buildPath(`${e.baseUrl}/queries`), t.map((e) => {
			let { fromDate: t, toDate: n, previousFromDate: r, previousToDate: i } = e;
			return {
				...e,
				fromDate: o(t),
				toDate: o(n),
				previousFromDate: o(r),
				previousToDate: o(i)
			};
		}), n));
	}
	export(t, n) {
		let { fromDate: r, toDate: i, previousFromDate: a, previousToDate: s } = t;
		return this.api.post(super.buildPath(`${e.baseUrl}/export`), {
			...t,
			fromDate: o(r),
			toDate: o(i),
			previousFromDate: o(a),
			previousToDate: o(s)
		}, n);
	}
}, l = class n extends e {
	static {
		this.baseUrl = `/data/restricted/organizations/${t.orgPlaceholder}/data/v1`;
	}
	constructor(e, t, n) {
		super(e, t, n);
	}
	listTables(e, t) {
		return this.internalAPI.get(super.buildPath(`${n.baseUrl}/tables`, e), t);
	}
	query(e, t) {
		return this.internalAPI.post(super.buildPath(`${n.baseUrl}/query`), e, t);
	}
};
//#endregion
export { c as DataServiceResource, l as RestrictedDataServiceResource };

//# sourceMappingURL=DataServiceResource.js.map